import { Dispatch } from 'react';
import { AnyAction } from 'redux';
import { AUTHENTICATION_ADMIN } from '../api';
import axios from '../axios';
import * as Types from '../types';

export const updateAuthenticationAdmin =
  (authSettings: Record<string, unknown>) =>
  async (dispatch: Dispatch<AnyAction>): Promise<unknown> => {
    const authenticationAdmin = await axios.put(AUTHENTICATION_ADMIN, {
      ...authSettings,
    });

    // Dispatch the org's authentication type & slug to update the redux store
    dispatch({
      payload: {
        authenticationType:
          authenticationAdmin.data.data.organisation.authenticationType,
        slug: authenticationAdmin.data.data.organisation.slug,
        authenticationAdmin: {
          ...authenticationAdmin.data.data,
        },
      },
      type: Types.OrganisationTypes.UPDATE_AUTH_TYPE,
    });

    // Return the remaining authentication settings data to the component
    return authenticationAdmin.data.data;
  };

export const getAuthenticationAdmin =
  () =>
  async (dispatch: Dispatch<AnyAction>): Promise<unknown> => {
    const authSettingsResult = await axios.get(AUTHENTICATION_ADMIN);

    dispatch({
      payload: { ...authSettingsResult.data.data },
      type: Types.OrganisationTypes.FETCH_AUTH_ADMIN,
    });

    return authSettingsResult.data.data;
  };
